import React from 'react'
import FormField from '@/components/common/FormField'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { useFormContext } from 'react-hook-form'
import { errorTypes } from '@/utility/validation'
import type { OnboardTabProps } from './onboard.types'

const OnboardSalaryDetail: React.FC<OnboardTabProps> = ({ isLoading, empId }) => {
    const { register, formState: { errors } } = useFormContext()

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <FormField
                    {...register("ctc", { ...errorTypes.required('CTC') })}
                    name="ctc"
                    label="CTC (Annual)"
                    type='number'
                    placeholder='Enter annual CTC'
                    error={errors.ctc?.message as string}
                />
                <FormField
                    {...register("basicSalary", { ...errorTypes.required('Basic Salary') })}
                    name="basicSalary"
                    label="Basic Salary"
                    type='number'
                    placeholder='Enter basic salary'
                    error={errors.basicSalary?.message as string}
                />
                <FormField
                    {...register("hra", { ...errorTypes.required('HRA') })}
                    name="hra"
                    label="HRA"
                    type='number'
                    placeholder='Enter HRA'
                    error={errors.hra?.message as string}
                />
                <FormField
                    {...register("otherAllowances")}
                    name="otherAllowances"
                    label="Other Allowances"
                    type='number'
                    placeholder='Enter other allowances'
                    error={errors.otherAllowances?.message as string}
                />
            </div>
            <div className="flex justify-end mt-6">
                <Button
                    type="submit"
                    disabled={isLoading}
                >
                    {isLoading ? <Spinner /> : (empId ? 'Update Employee' : 'Create Employee')}
                </Button>
            </div>
        </div>
    )
}

export default OnboardSalaryDetail
